import { render, staticRenderFns } from "./Global_realtime.vue?vue&type=template&id=58568f6e&scoped=true&"
import script from "./Global_realtime.vue?vue&type=script&lang=js&"
export * from "./Global_realtime.vue?vue&type=script&lang=js&"
import style0 from "./Global_realtime.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Global_realtime.vue?vue&type=style&index=1&id=58568f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58568f6e",
  null
  
)

export default component.exports